[
  {
    "colecciones": 
      {
        "español": 
        [
          {
            "value": "Todo",
            "name": "Todo"
          },
          {
            "value": "Areageograficas",
            "name": "Áreas geográficas"
          },{
            "value": "Datos_abiertos",
            "name": "Datos abiertos"
          },{
            "value": "DENUE",
            "name": "DENUE"
          },{
            "value": "Glosario",
            "name": "Glosario"
          },{
            "value": "Herramientas",
            "name": "Herramientas"
          },{
            "value": "Indicadores",
            "name": "Indicadores"
          },{
            "value": "Infraestructura",
            "name": "Infraestructura de la información"
          },{
            "value": "Investigación",
            "name": "Investigación"
          },{
            "value": "Mapas",
            "name": "Mapas"
          },{
            "value": "Microdatos",
            "name": "Microdatos"
          },{
            "value": "Noticias",
            "name": "Noticias"
          },{
            "value": "Programas",
            "name": "Programas de información"
          },{
            "value": "Publicaciones",
            "name": "Publicaciones"
          },{
            "value": "Tabulados",
            "name": "Tabulados"
          },{
            "value": "Temas",
            "name": "Temas"
          }
        ],
        "ingles": 
        [
          {
            "value": "Todo",
            "name": "All"
          },
          {
            "value": "DENUE",
            "name": "DENUE"
          },{
            "value": "Areageograficas",
            "name": "Geographic area"
          },{
            "value": "Glosario",
            "name": "Glossary"
          },{
            "value": "Indicadores",
            "name": "Indicators"
          },{
            "value": "Infraestructura",
            "name": "Information infrastructure"
          },{
            "value": "Programas",
            "name": "Information programs"
          },{
            "value": "Investigación",
            "name": "Investigation"
          },{
            "value": "Mapas",
            "name": "Maps"
          },{
            "value": "Microdatos",
            "name": "Microdata"
          },{
            "value": "Noticias",
            "name": "News"
          },{
            "value": "Datos_abiertos",
            "name": "Open data"
          },{
            "value": "Publicaciones",
            "name": "Publications"
          },{
            "value": "Tabulados",
            "name": "Tabular data"
          },{
            "value": "Herramientas",
            "name": "Tools"
          },{
            "value": "Temas",
            "name": "Topics"
          }
        ]
      },
    "OrderTodos":{
      "español": 
      [
        {
          "value": "RANKING",
          "name": "Por proximidad"
        },
        {
          "value": "VISITAS",
          "name": "Por lo más consultado"
        }
      ],
      "ingles": 
      [
        {
          "value": "RANKING",
          "name": "By proximity"
        },
        {
          "value": "VISITAS",
          "name": "By the most consulted"
        }
      ]
    },
    "areas":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Nombre del área geográfica"
            },
            {
              "value": "UBICACION_GEOGRAFICA",
              "name": "Clave del área geográfica"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Geographic area name"
            },
            {
              "value": "UBICACION_GEOGRAFICA",
              "name": "By geographic area key"
            }
          ]
    },
    "areasOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por nombre del área geográfica"
            },
            {
              "value": "UBICACION_GEOGRAFICA",
              "name": "Por clave del área geográfica"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By geographic area name"
            },
            {
              "value": "UBICACION_GEOGRAFICA",
              "name": "By geographic area key"
            }
          ]
    },
    "datosAbiertos":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Descripción"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "Programa"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Title"
            },
            {
              "value": "DESCRIPCION",
              "name": "Description"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "Program"
            }
          ]
    },
    "datosAbiertosOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "Por programa"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By title"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "By program"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            }
          ]
    },
    "denue":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "NOMBRE",
              "name": "Establecimiento económico"
            },
            {
              "value": "DES_ENTIDAD",
              "name": "Entidad federativa"
            },
            {
              "value": "DES_MUNICIPIO",
              "name": "Municipio"
            },
            {
              "value": "DES_LOCALIDAD",
              "name": "Localidad"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "NOMBRE",
              "name": "Economic establishment"
            },
            {
              "value": "DES_ENTIDAD",
              "name": "Federal entity"
            },
            {
              "value": "DES_MUNICIPIO",
              "name": "Municipality"
            },
            {
              "value": "DES_LOCALIDAD",
              "name": "Locality"
            }
          ]
    },
    "denueOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "NOMBRE",
              "name": "Por establecimiento económico"
            },
            {
              "value": "DES_ENTIDAD",
              "name": "Por entidad federativa"
            },
            {
              "value": "DES_MUNICIPIO",
              "name": "Por municipio"
            },
            {
              "value": "DES_LOCALIDAD",
              "name": "Por localidad"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "NOMBRE",
              "name": "By economic establishment"
            },
            {
              "value": "DES_ENTIDAD",
              "name": "By federal entity"
            },
            {
              "value": "DES_MUNICIPIO",
              "name": "By municipality"
            },
            {
              "value": "DES_LOCALIDAD",
              "name": "By locality"
            } 
          ]
    },
    "glosario":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "CONCEPTOS",
              "name": "Concepto"
            },
            {
              "value": "DEFINICIONES",
              "name": "Definición"
            },
            {
              "value": "DESCRIPCIONES",
              "name": "Programa"
            } 
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "CONCEPTOS",
              "name": "Concept"
            },
            {
              "value": "DEFINICIONES",
              "name": "Definition"
            },
            {
              "value": "DESCRIPCIONES",
              "name": "Program"
            } 
          ]
    },
    "glosarioOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "CONCEPTOS",
              "name": "Por concepto"
            },
            {
              "value": "DEFINICIONES",
              "name": "Por definición"
            },
            {
              "value": "DESCRIPCIONES",
              "name": "Por programa"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última Actualización"
            } 
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "CONCEPTOS",
              "name": "By concept"
            },
            {
              "value": "DEFINICIONES",
              "name": "By definition"
            },
            {
              "value": "DESCRIPCIONES",
              "name": "By program"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            } 
          ]
    },
    "herramientasOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            } 
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            } 
          ]
    },
    "indicadores":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Nombre del indicador"
            },
            {
              "value": "INDICADOR",
              "name": "Clave del indicador"
            },
            {
              "value": "TEMATICA",
              "name": "Ruta temática"
            },
            {
              "value": "FUENTE_DESCRIPCION",
              "name": "Fuente"
            },
            {
              "value": "PERIODOS",
              "name": "Período"
            }  
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Indicator name"
            },
            {
              "value": "INDICADOR",
              "name": "Indicator key"
            },
            {
              "value": "TEMATICA",
              "name": "Thematic route"
            },
            {
              "value": "FUENTE_DESCRIPCION",
              "name": "Source"
            },
            {
              "value": "PERIODOS",
              "name": "Period"
            }  
          ]
    },
    "indicadoresOrdenar":{
      "español": 
      [
        {
          "value": "RANKING",
          "name": "Por proximidad"
        },
        {
          "value": "TITULO",
          "name": "Por nombre del indicador"
        },
        {
          "value": "INDICADOR",
          "name": "Por clave del indicador"
        },
        {
          "value": "TEMATICA",
          "name": "Por ruta temática"
        },
        {
          "value": "FUENTE_DESCRIPCION",
          "name": "Por fuente"
        },
        {
          "value": "PERIODOS",
          "name": "Por período"
        },
        {
          "value": "FECHA_PUBLICACION",
          "name": "Por última actualización"
        },
        {
          "value": "VISITAS",
          "name": "Por lo más consultado"
        }    
      ],
      "ingles": 
      [
        {
          "value": "RANKING",
          "name": "By proximity"
        },
        {
          "value": "TITULO",
          "name": "By indicator name"
        },
        {
          "value": "INDICADOR",
          "name": "By indicator key"
        },
        {
          "value": "TEMATICA",
          "name": "By thematic route"
        },
        {
          "value": "FUENTE_DESCRIPCION",
          "name": "By source"
        },
        {
          "value": "PERIODOS",
          "name": "By period"
        },
        {
          "value": "FECHA_PUBLICACION",
          "name": "By last update"
        },
        {
          "value": "VISITAS",
          "name": "By the most consulted"
        }    
      ]
    },
    "infraestructura":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Descripción"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Title"
            },
            {
              "value": "DESCRIPCION",
              "name": "Description"
            }
          ]
    },
    "infraestructuraOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By title"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            }
          ]
    },
    "investigacion":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Descripción"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Title"
            },
            {
              "value": "DESCRIPCION",
              "name": "Description"
            }
          ]
    },
    "investigacionOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por título"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By title"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By the most consulted"
            }
          ]
    },
  "mapasOrdenar":{
  "español": 
  [
    {
      "value": "RANKING",
      "name": "Por proximidad"
    },
    {
      "value": "FECHA_PUBLICACION",
      "name": "Por última actualización"
    },
    {
      "value": "VISITAS",
      "name": "Por lo más consultado"
    }
  ],
  "ingles": 
  [
    {
      "value": "RANKING",
      "name": "By proximity"
    },
    {
      "value": "FECHA_PUBLICACION",
      "name": "By last update"
    },
    {
      "value": "VISITAS",
      "name": "By the most consulted"
    }
  ]
},
    "microdatos":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Título del microdato"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "Programa"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Microdata title"
            },
            {
              "value": "PROGRAMA_TEMA",
              "name": "Program"
            }
          ]
    },
    "microdatosOrdenar":{
      "español": 
      [
        {
          "value": "RANKING",
          "name": "Por proximidad"
        },
        {
          "value": "TITULO",
          "name": "Por título del microdato"
        },
        {
          "value": "PROGRAMA_TEMA",
          "name": "Por programa"
        },
        {
          "value": "FECHA_PUBLICACION",
          "name": "Por última actualización"
        },
        {
          "value": "VISITAS",
          "name": "Por lo más consultado"
        }
      ],
      "ingles": 
      [
        {
          "value": "RANKING",
          "name": "By proximity"
        },
        {
          "value": "TITULO",
          "name": "By microdata title"
        },
        {
          "value": "PROGRAMA_TEMA",
          "name": "By program"
        },
        {
          "value": "FECHA_PUBLICACION",
          "name": "By last update"
        },
        {
          "value": "VISITAS",
          "name": "By the most consulted"
        }
      ]
    },
    "noticias":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Título de la noticia"
            },
            {
              "value": "FUENTE",
              "name": "Programa"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "News title"
            },
            {
              "value": "DESCRIPCION",
              "name": "Program"
            }
          ]
    },
    "noticiasOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por título de la noticia"
            },
            {
              "value": "FUENTE",
              "name": "Por programa"
            },
            {
              "value": "DESCRIPCION_NOTICIA",
              "name": "Por descripción"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By news title"
            },
            {
              "value": "FUENTE",
              "name": "By program"
            },
            {
              "value": "DESCRIPCION_NOTICIA",
              "name": "By description"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            }
          ]
    },
    "programas":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Nombre del programa"
            },
            {
              "value": "DESCRIPCION",
              "name": "Descripción"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Program name"
            },
            {
              "value": "DESCRIPCION",
              "name": "Description"
            }
          ]
    },
    "programasOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por nombre del programa"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By program name"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            }
          ]
    },
    "publicaciones":{
      "español": 
      [
        {
          "value": "CBUSQUEDA",
          "name": "Todo"
        },
        {
          "value": "TITULO",
          "name": "Título de la publicación"
        },
        {
          "value": "DESC_ENTIDAD",
          "name": "Entidad federativa"
        },
        {
          "value": "EDICION",
          "name": "Edición"
        },
        {
          "value": "TEMPORALIDAD",
          "name": "Temporalidad"
        },
        {
          "value": "COBERTURA",
          "name": "Cobertura"
        },
        {
          "value": "DESCRIPCION",
          "name": "Descripción"
        },
        {
          "value": "ISBN",
          "name": "ISBN"
        },
        {
          "value": "UPC",
          "name": "UPC"
        }
      ],
      "ingles": 
      [
        {
          "value": "CBUSQUEDA",
          "name": "All"
        },
        {
          "value": "TITULO",
          "name": "Publication title"
        },
        {
          "value": "DESC_ENTIDAD",
          "name": "Federal entity"
        },
        {
          "value": "EDICION",
          "name": "Edition"
        },
        {
          "value": "TEMPORALIDAD",
          "name": "Temporality"
        },
        {
          "value": "COBERTURA",
          "name": "Coverage geographic"
        },
        {
          "value": "DESCRIPCION",
          "name": "Description"
        },
        {
          "value": "ISBN",
          "name": "ISBN"
        },
        {
          "value": "UPC",
          "name": "UPC"
        }
      ]
    },
    "publicacionesOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por título de la publicación"
            },
            {
              "value": "DESC_ENTIDAD",
              "name": "Por entidad federativa"
            },
            {
              "value": "EDICION",
              "name": "Por edición"
            },
            {
              "value": "TEMPORALIDAD",
              "name": "Por temporalidad"
            },
            {
              "value": "COBERTURA",
              "name": "Por cobertura"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            },
            {
              "value": "ISBN",
              "name": "ISBN"
            },
            {
              "value": "UPC",
              "name": "UPC"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By publication title"
            },
            {
              "value": "DESC_ENTIDAD",
              "name": "By federal entity"
            },
            {
              "value": "EDICION",
              "name": "By edition"
            },
            {
              "value": "TEMPORALIDAD",
              "name": "By temporality"
            },
            {
              "value": "COBERTURA",
              "name": "By coverage geographic"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            },
            {
              "value": "ISBN",
              "name": "ISBN"
            },
            {
              "value": "UPC",
              "name": "UPC"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            }
          ]
    },
    "tabulados":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "­Nombre del tabulado"
            },
            {
              "value": "AREAGEOGRAFICA",
              "name": "Nombre del área geográfica"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Tabular name"
            },
            {
              "value": "AREAGEOGRAFICA",
              "name": "Geographic area name"
            }
          ]
    },
    "tabuladosOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por nombre del tabulado"
            },
            {
              "value": "AREAGEOGRAFICA",
              "name": "Por nombre del área geográfica"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By tabular namea"
            },
            {
              "value": "AREAGEOGRAFICA",
              "name": "By geographic area name"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            }
          ]
    },
    "temas":{
          "español": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "Todo"
            },
            {
              "value": "TITULO",
              "name": "Nombre del tema"
            },
            {
              "value": "DESCRIPCION",
              "name": "Descripción"
            }
          ],
          "ingles": 
          [
            {
              "value": "CBUSQUEDA",
              "name": "All"
            },
            {
              "value": "TITULO",
              "name": "Topic name"
            },
            {
              "value": "DESCRIPCION",
              "name": "Description"
            }
          ]
    },
    "temasOrdenar":{
          "español": 
          [
            {
              "value": "RANKING",
              "name": "Por proximidad"
            },
            {
              "value": "TITULO",
              "name": "Por nombre del tema"
            },
            {
              "value": "DESCRIPCION",
              "name": "Por descripción"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "Por última actualización"
            },
            {
              "value": "VISITAS",
              "name": "Por lo más consultado"
            }
          ],
          "ingles": 
          [
            {
              "value": "RANKING",
              "name": "By proximity"
            },
            {
              "value": "TITULO",
              "name": "By topic name"
            },
            {
              "value": "DESCRIPCION",
              "name": "By description"
            },
            {
              "value": "FECHA_PUBLICACION",
              "name": "By last update"
            },
            {
              "value": "VISITAS",
              "name": "By the most consulted"
            }
          ]
    }
  }
]